import { AxiosResponse } from "axios";
import { put, call, throttle } from "redux-saga/effects";
import {
  failedUserGivenDetails,
  failedDeleteLocation,
  successDeleteLocation,
  successUserGivenDetails,
  updateDeleteLocation,
  failedaddFavRestaurants,
  successaddFavRestaurants,
  userActions,
  editEmailRequest,
  editEmailSuccess,
  editEmailFailure,
  setPromoConsentSuccess,
  setPromoConsentFailure,
  getUserGivenDetails,
  updateUserDetailsSuccess,
  updateUserDetailsFailure,
  usedMobileorEmail,
  setUserDetails,
} from "./userActions";
import {
  getUserDetails,
  updateLocationDetails,
  addFavRestaurant,
  updateEmail,
  promoConsent,
  updateUserDetails,
} from "./userAPI";
import {
  USERGIVEN_DETAIL_REQUEST,
  LOCATION_DELETE_REQUEST,
  ADD_FAV_RESTAURANT,
  EDIT_EMAIL_REQUEST,
  SET_PROMO_CONSENT_REQUEST,
  UPDATE_USER_DETAILS_REQUEST,
} from "./userConstants";
import {
  AddFavRestaurants,
  LocationDetails,
  UpdateUserDetailsPayload,
  UserGivenDetail,
} from "./userModels";
import { decryptJson } from "../../utils/react-ec-utils";
import {  GUEST_EMAIL, GUEST_MOBILE_NUMBER, GUEST_USER_NAME,  USER_DETAILS, USER_ID } from "../../constants";
import { updateProfileFailure } from "../auth/AuthActions";
import { getCookie, setCookie } from "../../../helper/cookieHelper";
import { validateAndParseResponse } from "../../utils/hmac-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";

const getUserContextFromCookies = () => {
  const userIDFromCookie = getCookie(USER_ID) || "";
  const userDetailsFromCookie = getCookie(USER_DETAILS) || {};
  return { userIDFromCookie, userDetailsFromCookie };
};

function* getUserGivenDetailsSaga(action: userActions):any {
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(getUserDetails, action.payload as any);
         const parsedResponse = yield call(
          validateAndParseResponse,
          response.data
        ); 
      
          if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
    // const decryptedData = decryptJson(response?.data?.encryptedText);
      const decryptedData = response?.data?.data
    if (response.status === 200) {
      yield put(successUserGivenDetails(decryptedData));
    }
  } catch (err) {
    yield put(failedUserGivenDetails());
  }
}

function* deleteUserLocation(action: userActions):any {
  const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      updateLocationDetails,
      action.payload as LocationDetails
    );
      const parsedResponse = yield call(
          validateAndParseResponse,
          response.data
        ); 
      
          if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }

    if (response.status === 200) {
      yield put(successDeleteLocation(response.data.data));
      const { userIDFromCookie, userDetailsFromCookie } = getUserContextFromCookies();
      yield put(getUserGivenDetails({
        email: userDetailsFromCookie?.email || "",
        mobilePhone: userDetailsFromCookie?.mobilePhone || "",
        customerId: userIDFromCookie || "",
      }));
    }
  } catch (err) {
    yield put(failedDeleteLocation({ message: "Please Try Again" }));
  }
}

function* addFavRest(action: userActions) :any{
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      addFavRestaurant,
      action.payload as AddFavRestaurants
    );
     const parsedResponse = yield call(
          validateAndParseResponse,
          response.data
        ); 
      
          if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
    if (response.status === 200) {
      yield put(successaddFavRestaurants(response.data.data));
    }
  } catch (err) {
    yield put(failedaddFavRestaurants({ message: "Please Try Again" }));
  }
}

function* editEmail(action: userActions):any {
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      updateEmail,
      action.payload as string
    );
     const parsedResponse = yield call(
          validateAndParseResponse,
          response.data
        ); 
      
          if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
    if (response.status === 200) {
      yield put(editEmailSuccess(response.data.data));
    }
  } catch (err) {
    yield put(editEmailFailure("Please Try Again"));
  }
}

// For Promotional Messages

function* setPromoConsentSaga(action: userActions) :any{
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      promoConsent,
      action.payload as number
    );
     const parsedResponse = yield call(
          validateAndParseResponse,
          response.data
        ); 
      
          if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
    if (response.status === 200) {
      yield put(setPromoConsentSuccess());
    }
  } catch (err) {
    yield put(setPromoConsentFailure("Please Try Again"));
  }
}

// For User Details Update
function* updateUserDetailsSaga(action: userActions):any {
   const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      updateUserDetails,
      action.payload as UpdateUserDetailsPayload
    );
         const parsedResponse = yield call(
              validateAndParseResponse,
              response.data
            ); 

            if(!parsedResponse?.valid)
                {
                  if (isMobile) {
                         showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                       } else {
                         showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                       }
                       return ;
                }
            
    // const safeDecrypt = (payload: any) => {
    //   try {
    //     return decryptJson(payload);
    //   } catch {
    //     return response?.data;
    //   }
    // };
    // const decryptedResponse = response?.data?.encryptedText
    //   ? safeDecrypt(response?.data?.encryptedText)
    //   : response?.data;
        const decryptedResponse = response?.data?.data
    const customerDetails = decryptedResponse?.customerDetails;
    const responseHttpStatus =
      decryptedResponse?.httpStatus !== undefined
        ? decryptedResponse?.httpStatus
        : response?.status;
    const requestPayload: any = action?.payload || {};
    const normalizedRequestEmail = String(requestPayload?.email || '').trim().toLowerCase();
    const normalizedResponseEmail = String(customerDetails?.email || '').trim().toLowerCase();
    const normalizedRequestMobile = String(requestPayload?.mobilePhone || '').replace(/\D/g, '');
    const normalizedResponseMobile = String(customerDetails?.mobilePhone || '').replace(/\D/g, '');
    const isMobileMatched =
      !normalizedRequestMobile ||
      normalizedRequestMobile === normalizedResponseMobile ||
      normalizedRequestMobile.endsWith(normalizedResponseMobile) ||
      normalizedResponseMobile.endsWith(normalizedRequestMobile);
    const isEmailMatched = !normalizedRequestEmail || normalizedRequestEmail === normalizedResponseEmail;
    const isValidUpdateResponse =
      responseHttpStatus === 200 &&
      Boolean(customerDetails?.customerId) &&
      isMobileMatched &&
      isEmailMatched;
    const userIDFromCookie = String(getCookie(USER_ID) || "");
    const userDetailsFromCookie = getCookie(USER_DETAILS) || {};

    if (isValidUpdateResponse) {
      const latestCustomerId = customerDetails?.customerId || requestPayload?.customerId || '';
      const latestEmail = customerDetails?.email || requestPayload?.email || '';
      const latestMobilePhone = customerDetails?.mobilePhone || requestPayload?.mobilePhone || '';
      const updatedCustomerDetails = {
        ...customerDetails,
        email: latestEmail,
        mobilePhone: latestMobilePhone,
      };

      // After successful update, fetch the updated user details
      localStorage.removeItem(GUEST_EMAIL);
      localStorage.removeItem(GUEST_MOBILE_NUMBER);
      localStorage.removeItem(GUEST_USER_NAME);
      latestCustomerId && setCookie(USER_ID, latestCustomerId);
      customerDetails && setCookie(USER_DETAILS, updatedCustomerDetails);

      // Keep Redux user.userDetails in sync with the freshly-written cookie.
      // New users complete signup through the EditProfile path (this update
      // flow), which never routes back through OtpScreenNew's setUserDetails.
      // Without this, state.user.userDetails keeps a previous session's user
      // until a page refresh — surfacing as the old name on the Rewards page.
      yield put(setUserDetails(updatedCustomerDetails));

      yield put(getUserGivenDetails({
        email: latestEmail,
        mobilePhone: latestMobilePhone,
        customerId: latestCustomerId,
      }));
      yield put(updateUserDetailsSuccess(decryptedResponse));
    } else {
      const decryptedMessage = String(decryptedResponse?.message || response?.data?.message || '');
 
      const backendMessage = decryptedMessage || response?.data?.message || '';
      const lowerBackendMessage = String(backendMessage).toLowerCase();
      if (lowerBackendMessage.includes('linked')) {
        if (lowerBackendMessage.includes('number is linked')) {
          yield put(usedMobileorEmail(action.payload.mobilePhone));
        } else {
          yield put(usedMobileorEmail(action.payload.email));
        }
      }
      const errorMessage = backendMessage;

 if(response.status!==200)
 {
yield put(updateProfileFailure(errorMessage));
      yield put(updateUserDetailsFailure(errorMessage));
 }
      
    }
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || '';

      if (String(errorMessage).includes('linked')) {
        if (String(errorMessage).includes('number is linked')) {
          yield put(usedMobileorEmail(action.payload.mobilePhone));
        } else {
          yield put(usedMobileorEmail(action.payload.email));
        }
      }

      yield put(updateProfileFailure(errorMessage));
      yield put(updateUserDetailsFailure(errorMessage));
    }
  }

export default function* userSaga() {
  yield throttle(3000, USERGIVEN_DETAIL_REQUEST, getUserGivenDetailsSaga);
  yield throttle(3000, ADD_FAV_RESTAURANT, addFavRest);
  yield throttle(3000, LOCATION_DELETE_REQUEST, deleteUserLocation);
  yield throttle(3000, EDIT_EMAIL_REQUEST, editEmail);
  yield throttle(3000, SET_PROMO_CONSENT_REQUEST, setPromoConsentSaga);
  yield throttle(3000, UPDATE_USER_DETAILS_REQUEST, updateUserDetailsSaga);
}
